import {
    Add,
    ArrowBackIos,
    ArrowForwardIos,
    AssignmentOutlined,
    Close,
    Print as PrintIcon
} from '@mui/icons-material';
import {
    Alert,
    Badge,
    FormControlLabel,
    IconButton,
    List,
    Menu,
    Modal,
    Snackbar,
    Switch
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { Col, Dropdown, Row } from 'antd';
import CommonEbookTooling from 'components/ebook';
import { TeacherStrategies, VideoSupport } from "components/ebook/EbookVideos";
import GraphicOrganizerAssignments from 'components/GraphicOrganizerAssignment';
import GraphicAssignmentPreview from 'components/GraphicOrganizerAssignmentPreview';
import LinkList from 'components/HyperlinkViewer';
import Interaction from 'components/Interaction';
import LessionPlanPrinter from "modules/lessonPlan/teacher/LessionPlanPrinter";
import Loading from 'components/Loading';
import BubbleNotes from 'components/Notes';
import OnestudyModals from 'components/OneStudy/OneStudyModal';
import OnegameModals from "components/OneGame/OneGameModal";
import PrintAction from "components/PrintAction";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useMobileDetect, useTabletDetection } from 'containers/chat/hooks';
import AssignmentForm from "features/forms/AssignmentForm";
import PageEditor from 'features/forms/PageEditor';
import { filter, find, findIndex, get, has, slice } from 'lodash';
import BingoModal from 'modules/bingoModule';
import ExtensionActivitiesTooling from 'modules/extraResource/teacher';
import SentenceViewTooling from 'modules/sentenceStarter/teacher/sentenceViewTooling';
import WorkSheetModal from 'modules/workSheet';
import "moment-timezone";
import linesSvg from "../utils/assets/images/lines.svg";
import SoyHistoriasIconUpdated from "../utils/assets/images/SoyHistoriasIconUpdated.svg";
import GrammerIconDrill from "../utils/assets/images/GrammerIconDrill.svg";
import PresentationIconSvg from "../utils/assets/images/Presentation-Icon.svg";
import AiActivityIcon from "../utils/assets/images/AiActivityIcon.svg";
import GenerateTestIcon from "../utils/assets/images/GenerateTestIcon.svg";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch} from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { useBookUnits } from 'store/booksUnits/selectors';
import { useAnswerView, useMainbookView, useSentenceView, usePDFView, useActivityStandardsView } from 'store/main_book_popup/selectors';
import { handleCreateBubbleNote } from 'store/notes/thunks';
import { useBookOrder } from 'store/books/selectors';
import { useClassTogglePermission, useCurrentOrgPermission, useOrgStandardCodes, useOrgTimezone } from 'store/organizations/selectors';
import { useServertime } from 'store/servertime/selectors';
import { useStory } from "store/story/selectors";
import { useWorkSheetSelector } from 'store/worksheet/selectors';
import styled from 'styled-components';
import { BACK_TO_BOOK, VIDEOS_DATA } from 'utils/config/reference';
import COLOR from 'utils/constants/color';
import { useSideDrawer } from 'utils/context/SideDrawerProvider';
import { generateUrlForNonEbook, getBookData, getCurrentResourceType, getPageData, getStoryUrl, modifyAssignmentForStudent, sortByCustomType, updateUrlPathWithActivityOrQuiz } from 'utils/lib/ebookHelper';
import { useShareNotification } from 'utils/methods/firebaseShareAssignment';
import { addPrintableClass, removePrintableClass } from 'utils/methods/textMethod';
import { useIsAdditionalBook } from 'utils/methods/functions';
import QuizHandler from './quiz/QuizHandler';
import AssignmentsComponent from 'modules/assignments';
import TeachersWorkSheet from 'modules/workSheet/TeachersWorkSheet';
import TeacherEditionList from 'modules/teacherEdition/teacher/TeacherEditionViewer';
import { updateUI } from 'store/UI/actions';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import LessonPlan from 'modules/lessonPlan/teacher';
import { useMatchMakingView } from 'store/main_book_popup/selectors';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useLearningModuleCount } from 'store/bingo/selectors';
import { isErrorContent } from "utils/methods/storyContentValidation";
import SentryWrap from 'components/Sentry';
import { useStandards } from 'store/story/selectors';
import { filterStateStandardByEnabledStates } from 'utils/lib/standardHelper';
import useStoryViewOpen from 'components/hooks/useStoryViewOpen';
import AssignmentBuilderTool from 'components/AssignmentBuilder/AssignmentBuilderTool';


const ParentContainer = styled.div`
  max-height: ${({ isStudent }) => (isStudent ? '709px' : '793px')};
  overflow-y: ${({ isEmpty }) => (isEmpty ? "scroll" : "auto")};
  overflow-x: hidden;
  backgroundColor: "#EFEFEF";
  padding-bottom: 50px !important;
  ::before {
    content: "";
    position: absolute;   
    margin: 0px;
    padding: 0px;
  }
    

  @media screen and (max-width: 1099px) {
    height: unset !important;
    padding-bottom: 50px !important;
  }
  @media screen and (max-width: 808px) {
    overflow: unset !important;
    min-height: 50vh !important;
    padding-bottom: 100px !important;
    max-height: unset !important;
    height: unset !important;
  }
`;

const StyledDropdown = styled(Dropdown)`
.ant-dropdown-menu {
    background-color: #7978c7 !important;
    border: none;
    padding: 0; /* Optional: remove padding for tighter fit */
  }
`;

const StyledMenuItem = styled.div`
  color: white; 
  border-bottom: 1px dotted white; 
  padding: 10px;
  &:hover {
    background-color: inherit !important; /* Keeps the same background color */
  }
`;

const ButtonClear = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
`;



// Main component with hamburger menu
const DropdownMenu = ({ isStudent, isTeacher, navigate, isAdmin }) => {
    const showAlert = useAlert();
    const handleMenuClick = (event) => {
    event.preventDefault();
    if (isAdmin) {
        showAlert("Please login as teacher!", "error");
    }
    };

    const menu = {
        items: [
          ...(isStudent ? [
            {
              key: 'calendar',
              label: (
              <ButtonClear onClick={() => navigate("calendar")}>
                  Calendar
              </ButtonClear>
              )
            },
            {
              key: 'studentData',
              label: (
              <ButtonClear onClick={() => navigate("studentData")}>
                  Student Data
              </ButtonClear>
              )
            }
          ] : []),
          ...(isTeacher ? [
            {
              key: 'home',
              label: (
              <ButtonClear onClick={() => navigate("home")}>
                  Home
             </ButtonClear>
              )
            },
            {
              key: 'gradebook',
              label: (
              <ButtonClear onClick={() => navigate("gradebook")}>
                  Gradebook
              </ButtonClear>
              )
            },
            {
              key: 'classdata',
              label: (
              <ButtonClear onClick={() => navigate("classdata")}>
                  Class Data
              </ButtonClear>
              )
            }
          ] : [])
        ],
        style: {
          backgroundColor: '#7978c7',
          border: 'none',
          padding: 0,
        }
      };
      
    return (
    <SentryWrap>
        <>
       {isAdmin ? (
        <IconButton aria-label="menu" onClick={handleMenuClick}>
          <img className="menuLinesImg" src={linesSvg} alt="Menu" title="Menu" />
        </IconButton>
       ) : (

      <Dropdown
        menu={menu}
        trigger={['click']} // Dropdown opens on click
        placement="bottomLeft" // Opens from the bottom-left
      >
        <IconButton aria-label="menu">
          <img className="menuLinesImg" src={linesSvg} alt="Menu" title="Menu" />
        </IconButton>
      </Dropdown>
       )} 
       </>
     </SentryWrap>
    );
  };
  


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const AssignmentDrawer = styled.div`
    background-color: #fcfcfc;
    height: 100%;
    overflow: auto;
    position: absolute;
    left: ${p => p.active ? '0px' : 'calc(100% + 32px)'};
    top: 50px;
    transition: left 300ms ease, width 300ms ease;
    width: ${p => p.active ? '100%' : '0px'};
    z-index: 1;
      @media Screen and (max-width:768px){
    height:unset;
    padding-bottom:50px;
  }
`;

// const ButtonClear = styled.button`
//     background-color: transparent;
//     border: none;
//     color: ${COLOR.white};
//     cursor: pointer;
//     height: 18px;
//     outline: none;
//     padding: 0px;
//     transition: all 300ms ease;

//     &:hover {
//         color: ${COLOR.black};
//     }
// `;

const ButtonLink = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${COLOR.black200};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 2px 0px;
    text-transform: uppercase;
`;

const CreationDrawer = styled(AssignmentDrawer)`
    height: 100%;
    padding: ${p => p.active ? '24px 12px' : '0px'};
`;

const EmptyState = styled.div`
    align-items: center;
    border: 1px dashed ${COLOR.black700};
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    padding: 16px 16px;
`;

const EmptyStateText = styled.span`
    color: ${COLOR.black500};
    display: block;
    font-size: 12px;
    font-weight: 500;
    margin: 8px 0px 0px;
    text-align: center;
`;

const FormDescription = styled.span`
    color: ${COLOR.black400};
    display: inline-block;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 24px;
`;

const FormHeader = styled.span`
    color: ${COLOR.black200};
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
`;



const Page = styled.div`
    align-items: center;
    color: ${COLOR.black100};
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
    width: 80px;
`;

const Section = styled.div`
    border-bottom: 1px dashed ${COLOR.black700};
    padding: 0px 0px 24px;
    margin-bottom: 16px;
    position: relative;
    &:first-child {
        border-bottom: none;
        margin-bottom: 0px;
        padding: 0px;
    }

    &:last-child {
        border-bottom: none;
        padding-bottom: 0px;
    }
`;
const PartitonDotted = styled.div`
border-bottom: 1px dashed ${COLOR.black};
width:100%;
height:1px;
margin-bottom: 16px;
margin-top: 16px;
`
const SectionHeader = styled.span`
    align-items: center;
    color: ${COLOR.black200};
    display: flex;
    flex-direction: row;
    font-size: 10px;
    font-weight: 600;
    justify-content: space-between;
    margin-bottom: 8px;
    text-transform: uppercase;
    width: 100%;
`;

const Toolbar = styled.div`
    align-items: center;
    border-bottom: 1px solid ${COLOR.black600};
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
`;


const Wrap = styled.div`
  align-items: flex-start;
  border-bottom:${p=>p.empty?'0px':'1px'} dashed ${COLOR.black800};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: ${p=>p.empty?'0px':'0px 0px'};
  padding-left: 10px;
  padding-top:${p => p.empty ? '0px' : '0px'};
  padding-bottom:${p => p.empty ? '0px' : '0px'};
  flex-wrap: wrap;
  justify-content: start;
`;

const Wrapper = styled.div`
     height: 100%;
  // min-height: 600px;
//   min-height: 904px;
  width: 100%;
  background-color: #e0e0e0;
  position: relative;

     @media (max-width: 1025px){
        min-height:unset;
    }
    @media (max-width: 768px){
        min-height:60vh;
    }
`;
// overflow: hidden;




const Video = styled.video`
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    height: auto;
    outline: none;
    width: 100%;
`;
const TimmerWrapper = styled.div`
color: ${COLOR.black100};
display: inline-block;
font-size: 14px;
font-weight: 600;
line-height: 16px;
position:absolute;
top:5px;
left:45%
`;
const LessionPlan = styled.button`
   background-image: linear-gradient(to right, rgb(189,38,95), rgb(217,87,61));
    // border: none;
    border:1px solid #015ECC;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left:4px;

    @media only screen and (max-width: 1025px){
      margin-top:5px;
    }

      @media (max-width: 992px) {
        // display:none;
      }
}
`;
const LessionPlanInner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border:1px solid #fff;
    padding-left: 10px;
    padding-right: 10px;
`;
const AssignmentPlan = styled.button`
    // background-image: linear-gradient(to right,${COLOR.indigo500}, ${COLOR.indigo600});
    background-color: #020A52;
    // border: none;
    border:1px solid #020A52;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    color: white;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;

    @media only screen and (max-width:  1025px){
      margin-top:5px;
    }
}
`;
const AssignmentPlanInner = styled.div`
  display: flex;
  // flex-direction: column;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 1px solid #fff;
  padding-left: 6px;
  padding-right: 6px;
`;
const TestGenerator = styled.button`
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 35.16px;
    max-height: 35.16px;
    border-radius: 18px;
    background: #002d75;
    cursor: pointer;
    color: white;
    flex: 1 1 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
`;
const LearnPlanWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: transparent;
    overflow: hidden;
`;
const LessionPlanContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 75%;
    // height: 90%;
    height: auto;
    position: relative;
    justify-content: center;
    padding: 20px;
    background-color: white;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    @media Screen and (min-width: 1200px) {
    width:50%;
  }
`;
const CloseBtn = styled.div`
    background-color: rgb(204,80,71);
    border: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 1;
`;
const ImageContainer = styled.div`
    display: flex;  
`;
const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    object-fit: cover;
    height:600px;
    @media (max-width: 768px) {
        height:400px;
    }
    @media (min-width: 768px) {
        height:620px;
    }
    @media (min-width: 1600px) {
        height:700px;
    }
    @media print {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
`;
const LessionImage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80%;
    height: 80%;
    background-color: transparent;
    overflow: hidden;
    position: relative;
    z-index: 1;
`;
const LessionContainer = styled.div`
    align-items: stretch;
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    max-width: 1320px;
    padding: 64px 0px 0px;
    position: relative;
    width: 100%;
    justify-content: center;
    align-items: center;
    @media (min-width: 1025px) {
        flex-direction: row;
        padding: 0px 30px;
    }
`;
const ButtonContainer = styled.button`
    background-color: transparent;
    border: none;
    color: ${COLOR.black600};
    cursor: pointer;
    height: 40px;
    left: ${p => `${p.left}px`};
    outline: none;
    position: absolute;
    right: ${p => `${p.right}px`};
    top: 50%;
    transition: all 300ms ease;
    width: 40px;
    z-index: 1;
    
`;
const PlannerWrapper = styled.div`
    width: max-content;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: wrap-reverse;
`;
const DummyBtn = styled.button`
    background-color: transparent;
    // cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 27.2px;
    z-index: 1;
    padding: 1px;
    font-size: 12.1px;
    font-weight: 400;
    margin-left: 4px;
    color:transparent;
    border-width:0px;
    @media only screen and (max-width: 1367px){
      margin-top:5px;
    }
}
`;
const PrintWrapper = styled.div`
`;

const StyledList = muiStyled(List)(({ theme }) => ({
  width: "100%",
  maxWidth: 360,
  backgroundColor: theme.palette.background.paper,
  '& .MuiListItem-padding': {
    paddingBottom: '0px',
    paddingTop: '0px'
  },
  '& .MuiListItem-root': {
    marginTop: '0px',
    marginBottom: '0px',
    textAlign: 'justify'
  },
  '& .MuiListItem-gutters': {
    paddingLeft: '3px',
    paddingRight: '1px'
  },
  '& .scroll': {
    height: '250px',
    overflowY: 'auto'
  }
}));

const StyledFormControlLabel = muiStyled(FormControlLabel)(({ theme }) => ({
  margin: '5px',
  '& .MuiSwitch-switchBase.Mui-checked': {
    transform: 'translateX(20px) !important'
  },
  '& .MuiFormControlLabel-label': {
    textTransform: 'uppercase'
  },
  '&.teacher-stag-root': {
    margin: '5px'
  }
}));

const StyledSwitch = muiStyled(Switch)({
  '&.MuiSwitch-sizeSmall': {
    width: "40px",
    height: "25px",
  },
  '& .Mui-checked': {
    transform: "translateX(17px) !important",
  }
});

//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook tooling
//
//  -- Description
//  Ebook student tooling
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const BalconCulturalTooling = ({
    classUsers,
    activity,
    activities,
    classActivities,
    classQuizzes,
    currentClass,
    currentOrg,
    currentUser,
    interactions,
    limit,
    notes,
    page,
    quiz,
    quizzes,
    data,
    ebookFlag,
    setEbookFlag,
    ebookFlagTeacherEdition,
    setEbookFlagTeacherEdition,
    submissions,
    tips,
    existTeacherEdition,
    existShowAnswer,
    showCopyRight,
    showSpecialSupport,
    setShowSpecialSupport,
    studentViewFlag,
    setStudentViewFlag,
    setSubmitRef,
    timeInt,
    timmer,
    onFinish,
    onPageChage = () => null,
    pageNumber,
    booksAllList,
    id,
    CHAPTER_ID,
    lessonPlan,
    rubrics,
    assignmentPlan,
    workbook_plan,
    main_book,
    unitExam,
    bookInfo,
    setPage,
    links,
    pageHyperlink,
    dataBook,
    pageSrc,
    handleImagePrint,
    printLoader,
    imageConfiguration,
    content,
    page_1game_ai_content,
    backToLabelStory,
    book,
    handleOpenStoryWithAi = () => {},
    hasStoryWithAi,
    handlerOpenPresentation = () => {},
    page_slide,
    handleGenerateAiAssignment = () => {},
    setToolsDropdown = () => {},
    storyId = null,
    storyLevel = null,
    BALCON_PAGES = []
}) => {
    const {checkPopUpAtOnce,updatePopUpAtOnce,openPopUpAtOnce} = usePopUpAtOnce();
    const isStoryViewOpen = useStoryViewOpen();
    const showAlert = useAlert();
    const { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer } = useSideDrawer();
    const getHiddenBooks = get(currentClass,"hide_books",[])?.map(data => data?.bookId) || [];
    // const bookUnitList = useBookUnits()
    // const BALCON_PAGES = get(find(bookUnitList, ["bookId", CHAPTER_ID]), "pages", [])
    const dispatch = useDispatch();
    const location = useLocation();
  	const navigate = useNavigate();
    const servertime = useServertime()
    const timezone = useOrgTimezone()
    const story = useStory()
    const {listenToSentenceData} = useShareNotification()
    const bookData =  getBookData(activities, quizzes, null, notes, null , interactions, classActivities, classQuizzes, CHAPTER_ID,currentClass.id,false,currentUser.id);
    const [isOpen, setIsOpen] = useState(false);
    const pageData = getPageData(bookData, page, quiz, activity)
    const [ebookFlagPageLink, setEbookFlagPageLink] = useState(false);
    
    const currentPageIndex = useMemo(() => {
        const pages = content || data?.content || [];
        const pageIndex = pages.findIndex(p => p.pageId == page);
        return pageIndex;
    }, [page, content, data]);
    
    // Learning module counts - SAME as EbookTooling
    const learningModuleCount = useLearningModuleCount();
    const pageLearningModuleCount = useMemo(() => {
        return learningModuleCount?.result?.find(item => String(item?.page) === String(page)) || {};
    }, [learningModuleCount, page]);

    const pageLearningModuleCountGames = useMemo(() => {
        return learningModuleCount?.games?.filter(item => String(item?.page_name) === String(pageNumber) || String(item?.page_name) === String(page)) || {};
    }, [learningModuleCount, page]);
    
    const pageLearningModuleCountStudy = useMemo(() => {
        return learningModuleCount?.study?.filter(item => String(item?.page_name) === String(pageNumber) || String(item?.page_name) === String(page)) || {};
    }, [learningModuleCount, page]);

     // lession plan 
     const hasLessionPlanPage = lessonPlan ? find(lessonPlan, p => p.page == page) : null;
     const lessonPlanBook = hasLessionPlanPage ? find(booksAllList, p => p.id == hasLessionPlanPage.resourceId) : null;
     const lessionPlanPages = get(lessonPlanBook, "pages", [])
     const [lessonPageindex, setLessionPageindex] = useState(0);
     const [lessionPrintLoader, setlessionPrintLoader] = useState(false)

    // rubrics plan 
    const hasRubricsPlanPage = rubrics ? find(rubrics, p => p.page == page) : null;
    const rubricsPlanBook = hasRubricsPlanPage ? find(booksAllList, p => p.id == hasRubricsPlanPage.resourceId) : null;
    const rubricsPlanPages = get(rubricsPlanBook, "pages", [])
    const [rubricsPageindex, setRubricsPageindex] = useState(0);
    const [rubricsPrintLoader, setRubricsPrintLoader] = useState(false)
    const [rubricsPlanModal, setRubricsPlanModal] = useState(false)

     // assignment plan
     const hasAssignmentPlanPage = assignmentPlan ? find(assignmentPlan, p => p.page == page) : null;
     const assignmentPlanBook = hasAssignmentPlanPage ? find(booksAllList, p => p.id == hasAssignmentPlanPage.resourceId) : null;
     const assignmentPlanPages = get(assignmentPlanBook, "pages", [])
     const [assignmentPageindex, setAssignmentPageindex] = useState(0);
     const [assignmentPrintLoader, setAssignmentPrintLoader] = useState(false);

     // Unit exam plan
    const hasUnitExamPlanPage = unitExam ? find(unitExam, p => p.page == page) : null;

    const unitExamPlanBook = hasUnitExamPlanPage
        ? find(booksAllList, (p) => p.id == hasUnitExamPlanPage.resourceId)
        : null;

    const unitExamPlanPages = get(unitExamPlanBook, "pages", []);
    const [unitExamPageIndex, setUnitExamPageindex] = useState(0);
    const [unitExamPrintLoader, setUnitExamPrintLoader] = useState(false);

        
    //workbook plan
    const hasWorkbookPlanPage = workbook_plan ? find(workbook_plan, p => p.page == page) : null;
    const WorkbookPlanBook = hasWorkbookPlanPage ? find(booksAllList, p => p.id == hasWorkbookPlanPage.resourceId) : null;
    const WorkbookPlanPages = get(WorkbookPlanBook, "pages", [])
    const [WorkbookPageindex, setWorkbookPageindex] = useState(0);
    const [workbookPlanModal, setWorkbookPlanModal] = useState(false)

    // ---------------- Answer ------------------------------
    const answer_page = filter(dataBook?.pagesTeacher, (item) => parseInt(item.pageId) === parseInt(page))

    // ---------------- PDF ------------------------------
    const pdf_page = find(dataBook?.pagesPDF, (item) => parseInt(item.pageId) === parseInt(page))

   //main book 
   const hasMain_bookPage = main_book ? find(main_book, p => p.page == page) : null;
   const mainBook = hasMain_bookPage ? find(booksAllList, p => p.id == hasMain_bookPage.resourceId) : null;
   const mainBookPages = get(mainBook, "pages", [])
   const { invokeMainbookView, revokeMainbookView } = useMainbookView()
   const { invokeSentenceView } = useSentenceView();
   const { invokeAnswerView, revokeAnswerView } = useAnswerView();
   const { pdfView, invokePDFView, revokePDFView } = usePDFView();
   const { matchMakingView } = useMatchMakingView();
   const { activityStandardsView, invokeActivityStandardsView, revokeActivityStandardsView } = useActivityStandardsView();
   const standards = useStandards();
   const orgPermissions = useCurrentOrgPermission();
   const enabledStateCodes = useOrgStandardCodes();
   const classTogglePermission = useClassTogglePermission();
   const bookOrder = useBookOrder();

    const isStudent = currentUser && currentUser.role === 'student'
    const isTeacher = currentUser && currentUser?.role === 'teacher'
    const isDistrictAdmin = currentUser && currentUser?.role === "admin";
    const isAdmin = currentUser && currentUser?.role === "admin";
    const [openGraphicAssignmentPrivew,setOpenGraphicAssignmentPrivew] = useState(false)
    const [graphicAssignment,setGraphicAssignment] = useState({})
    // Sentence Starter
    const [sentenceData, setSentenceData] = useState({})
    const isAdditionalBook = useIsAdditionalBook(CHAPTER_ID);
    const isSentenceStarterAllowedForBookGroup = useMemo(() => {
        if (!isStudent) return true;
        if (!classTogglePermission.sentence_starters) return true; // Default to allowed if no restrictions
        const currentBookGroup = bookOrder?.find((order) => order.order && order.order.includes(CHAPTER_ID));
        if (!classTogglePermission?.sentence_starters || Object.keys(classTogglePermission.sentence_starters).length === 0) {
            return false;
        }
        if (!has(classTogglePermission.sentence_starters, currentBookGroup?.key || isAdditionalBook?.key)) return true;

        if (isAdditionalBook?.key) {
            if (orgPermissions[isAdditionalBook?.key]) {
                return classTogglePermission.sentence_starters[isAdditionalBook?.key];
            }
        }

        return classTogglePermission.sentence_starters[currentBookGroup?.key];
    }, [isStudent, bookOrder, CHAPTER_ID, classTogglePermission?.sentence_starters, isAdditionalBook, orgPermissions]);
    
    const [aiModals, setAiModals] = useState(false);
    const [studyModals, setStudyModals] = useState(false);

    const [teacher_strategies, setTeacherStrategies] = useState(false);
    
    const [learnPlanModal, setLearnPlanModal] = useState(false)
    const [assignmentPlanModal, setAssignmentPlanModal] = useState(false);
    const [unitExamPlanModal,setUnitExamPlanModal] = useState(false);
    const [preview, setPreview] = useState(false)
    const [assignmentData, setAssignmentData] = useState({})
    const [creationType, setCreationType] = useState(null);
    const pageInteractions = pageData.pageInteractions;
    const ap_video = useMemo(()=>{
        const video_dt = VIDEOS_DATA.find(k=>k.id==CHAPTER_ID);
        if(video_dt){
            video_dt.content = video_dt.video;
            video_dt.typeId = "video"
        }
        return video_dt;
    },[CHAPTER_ID])
    const videoSupport = pageData.videoSupport;
    const pageNotes = pageData.pageNotes;
    const availableActivity = modifyAssignmentForStudent(pageData.availableActivity, isStudent, false, currentUser, servertime, timezone , currentClass,getHiddenBooks);

    const modAssignableActivity = pageData.assignableActivity;

     const assignableActivity = useMemo(() => {
        const data = sortByCustomType(modAssignableActivity);
        const xyz = data?.filter((x) => x?.type?.toLowerCase() !== "custom");
    
        const sortedActivities = [...xyz].sort((a, b) => {
          const seqA = parseInt(a.sequence_order) || 0;
          const seqB = parseInt(b.sequence_order) || 0;
          return seqA - seqB;
        });
    
        const finalResult = [
          ...sortedActivities,
          ...data?.filter((x) => x?.type?.toLowerCase() === "custom"),
        ];
        return finalResult;
      }, [modAssignableActivity]);    
    const activeActivity = pageData.activeActivity;
    const availableQuiz = modifyAssignmentForStudent(pageData.availableQuiz, isStudent, true, currentUser, servertime, timezone , currentClass,getHiddenBooks);
    const modAssignableQuiz = pageData.assignableQuiz;
      const assignableQuiz = useMemo(() => {
        const data = sortByCustomType(modAssignableQuiz);
        const xyz = data?.filter((x) => x?.type?.toLowerCase() !== "custom");
    
        const sortedActivities = [...xyz].sort((a, b) => {
          const seqA = parseInt(a.sequence_order) || 0;
          const seqB = parseInt(b.sequence_order) || 0;
          return seqA - seqB;
        });
    
        const finalResult = [
          ...sortedActivities,
          ...data?.filter((x) => x?.type?.toLowerCase() === "custom"),
        ];
        return finalResult;
      }, [modAssignableQuiz]);

    const activeQuiz = pageData.activeQuiz;
    
    const hasActivitiesWithStandards = useMemo(() => {
        const pageActivities = filter(bookData.activities, (activity) => {
            const activityPage = get(activity, 'page') || get(activity, 'data.page');
            return String(activityPage) === String(page);
        });
        
        const pageClassActivities = filter(bookData.classActivities || [], (classActivity) => {
            const activityPage = get(classActivity, 'data.page');
            return String(activityPage) === String(page);
        });
        
        const pageQuizzes = filter(bookData.quizzes || [], (quiz) => {
            const quizPage = get(quiz, 'page') || get(quiz, 'data.page');
            return String(quizPage) === String(page);
        });
        
        const pageClassQuizzes = filter(bookData.classQuizzes || [], (classQuiz) => {
            const quizPage = get(classQuiz, 'data.page');
            return String(quizPage) === String(page);
        });
        
        const allActivities = [...(assignableActivity || []), ...(availableActivity || []), ...(assignableQuiz || []), ...(availableQuiz || []), ...pageActivities, ...pageClassActivities, ...pageQuizzes, ...pageClassQuizzes];
        const uniqueActivities = [];
        const seenIds = new Set();
        
        allActivities.forEach(activity => {
            const dataId = get(activity, 'data.id');
            const activityId = get(activity, 'activityId');
            const wrapperId = get(activity, 'id');
            const finalId = dataId || activityId || wrapperId;
            
            if (finalId && !seenIds.has(finalId)) {
                seenIds.add(finalId);
                uniqueActivities.push(activity);
            }
        });
        
        const activitiesWithStandards = uniqueActivities.filter(activity => {
            const questionsDirect = get(activity, 'questions', []);
            const questionsNested = get(activity, 'data.questions', []);
            const questions = Array.isArray(questionsDirect) && questionsDirect.length > 0 ? questionsDirect : (Array.isArray(questionsNested) ? questionsNested : []);
            if (!Array.isArray(questions) || questions.length === 0) return false;
            
            return questions.some(q => {
                if (!q || !q.state_standard || !Array.isArray(q.state_standard)) return false;
                const filteredStateStandards = filterStateStandardByEnabledStates(q.state_standard, enabledStateCodes);
                return filteredStateStandards.some(ss => ss && ss.standard && Array.isArray(ss.standard) && ss.standard.length > 0);
            });
        });
        
        return activitiesWithStandards.length > 0;
    }, [assignableActivity, availableActivity, assignableQuiz, availableQuiz, bookData, page, enabledStateCodes]);

    const allActivitiesForStandards = useMemo(() => {
        const pageActivities = filter(bookData.activities, (activity) => {
            const activityPage = get(activity, 'page') || get(activity, 'data.page');
            return String(activityPage) === String(page);
        });
        
        const pageClassActivities = filter(bookData.classActivities || [], (classActivity) => {
            const activityPage = get(classActivity, 'data.page');
            return String(activityPage) === String(page);
        });
        
        const pageQuizzes = filter(bookData.quizzes || [], (quiz) => {
            const quizPage = get(quiz, 'page') || get(quiz, 'data.page');
            return String(quizPage) === String(page);
        });
        
        const pageClassQuizzes = filter(bookData.classQuizzes || [], (classQuiz) => {
            const quizPage = get(classQuiz, 'data.page');
            return String(quizPage) === String(page);
        });
        
        const allActivities = [...(assignableActivity || []), ...(availableActivity || []), ...(assignableQuiz || []), ...(availableQuiz || []), ...pageActivities, ...pageClassActivities, ...pageQuizzes, ...pageClassQuizzes];
        const uniqueActivities = [];
        const seenIds = new Set();
        
        allActivities.forEach(activity => {
            const dataId = get(activity, 'data.id');
            const activityId = get(activity, 'activityId');
            const wrapperId = get(activity, 'id');
            const finalId = dataId || activityId || wrapperId;
            
            if (finalId && !seenIds.has(finalId)) {
                seenIds.add(finalId);
                uniqueActivities.push(activity);
            }
        });
        
        const filtered = uniqueActivities.filter(activity => {
            const questionsDirect = get(activity, 'questions', []);
            const questionsNested = get(activity, 'data.questions', []);
            const questions = Array.isArray(questionsDirect) && questionsDirect.length > 0 ? questionsDirect : (Array.isArray(questionsNested) ? questionsNested : []);
            if (!Array.isArray(questions) || questions.length === 0) return false;
            
            return questions.some(q => {
                if (!q || !q.state_standard || !Array.isArray(q.state_standard)) return false;
                return q.state_standard.some(ss => ss && ss.standard && Array.isArray(ss.standard) && ss.standard.length > 0);
            });
        });
        
        return filtered;
    }, [assignableActivity, availableActivity, assignableQuiz, availableQuiz, bookData, page]);
    
    const backBtnRef = useRef(null)
    const forwardBtnRef = useRef(null)
    const hasteacherEdition =useMemo(()=>get(orgPermissions,"teacherEdition",true),[orgPermissions])
    const [alertSakeBar,setAlertSakeBar] = useState({open:false,message:''})
    const [customAssignmentDrawer, setCustomAssignmentDrawer] = useState(false);
    const [assignmentBuilderOpen, setAssignmentBuilderOpen] = useState(false);
    const [assignmentBuilderSeed, setAssignmentBuilderSeed] = useState(null);
    const isDemo = currentUser?.demo || false;
    const listWorkSheet = useWorkSheetSelector();
    const isReviewAccount = currentUser?.reviewAccount || false;
    
    const generateUrl = (page, activity, quiz) => {
        const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
        const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
        const url = generateUrlForNonEbook(id,page,activity,quiz,backToLabel,null,CHAPTER_ID,false)
        if (url && backToLabel) {
            return url;
        }
        else if (storyUrl) {
            return storyUrl;
        } else{
            updateUrlPathWithActivityOrQuiz(window.location.href, activity, quiz)
        }
       
    }
    const assignmentAllRefs = useRef(null);

    const dataList = listWorkSheet?.filter((item) => item?.page_id === page && item?.book_id === CHAPTER_ID);

    const isTablate = useTabletDetection();
    const isMobile = useMobileDetect() && !isTablate;

    useEffect(() => {
        const unsubscribe = listenToSentenceData("admin_sentence", (data) => {
            setSentenceData(data?.admin_sentence);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        onPageChage(onPageSwipe)
    }, [onPageChage])


    let infoClassUSers = filter(classUsers, x => x.role === 'student');
    let listStudents = [];
    for (var u in infoClassUSers) {
        listStudents.push({
            id: infoClassUSers[u].id,
            description: `${infoClassUSers[u].lastName}  ${infoClassUSers[u].firstName} (${infoClassUSers[u].username})`
        })
    }
       
    const getSrcPage = () => {
        if (lessionPlanPages) {
            const page = lessionPlanPages[lessonPageindex];
            return page ? page.resource : null
        }
    }
    const getSrcAssignmentPage = () => {
        if (assignmentPlanPages) {
            const page = assignmentPlanPages[assignmentPageindex];
            return page ? page.resource : null
        }
    }

    const getSrcUnitExamPage = () => {
        if (unitExamPlanPages) {
            const page = unitExamPlanPages[unitExamPageIndex];
            return page ? page.resource : null
        }
    }

    const getSrcWorkbookPage = () => {
        if (WorkbookPageindex>=0&&WorkbookPlanPages&&WorkbookPlanPages.length>0) {
            const page = WorkbookPlanPages[WorkbookPageindex];
            return page ? page.resource : null
        }
    }
    const getSrcRubricsPage = () => {
        if (rubricsPlanPages) {
            const page = rubricsPlanPages[rubricsPageindex];
            return page ? page.resource : null
        }
    }
    useEffect(() => {
        document.addEventListener('keydown', checkKey);
        return () => {
            document.removeEventListener("keydown", () => { })
        }
    }, [])
    function checkKey(e) {
        let isLessonPlan = document.getElementsByClassName("lessonPlanPopUp").length > 0;
        let isRubricsPlan = document.getElementsByClassName("rubricsPopUp").length > 0;
        if (isLessonPlan || isRubricsPlan) {
            e = e || window.event;
            if (e.keyCode == '37') {
                if (backBtnRef.current && !backBtnRef.current.disabled) {
                    backBtnRef.current.click()
                }

            }
            else if (e.keyCode == '39') {
                if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
                    forwardBtnRef.current.click()
                }

            }
        }
    }
    const imageRef = useRef();
    
    const handlePrintLessons = () => {
        if (isMobile || isTablate) {
            showAlert("Print is not supported on this device!", "error");
            return;
        }
        else{
        addPrintableClass()
        handleLessionImagePrint()
        }
    }
    
    const handleLessionImagePrint = useReactToPrint({
        contentRef: imageRef,
        onBeforeGetContent: async () => {
            setlessionPrintLoader(true)
            setAssignmentPrintLoader(true)
            setRubricsPrintLoader(true);
            setUnitExamPrintLoader(true);
        },
        onBeforePrint: async () => {
            setlessionPrintLoader(false)
            setAssignmentPrintLoader(false)
            setRubricsPrintLoader(false);
            setUnitExamPrintLoader(false);
        },
        onAfterPrint: async () => {
            setlessionPrintLoader(false)
            setAssignmentPrintLoader(false)
            setRubricsPrintLoader(false);
            setUnitExamPrintLoader(false);
            removePrintableClass();

        }
    });
  
    const tipsTalented =  filter(tips, x => x.texType === 'talented');
    const tipsSpecial = filter(tips, x => x.texType === 'special');

    const  existSpecialSupport = useMemo(()=>videoSupport&&videoSupport.length > 0,[videoSupport]);

    let existStudentView = false;
    if (availableActivity.length || availableQuiz.length > 0) {
        existStudentView = true;
    }


    const createNote = (data, color) => {
        dispatch(handleCreateBubbleNote({
            content: data,
            color: color,
            chapter: CHAPTER_ID,
            page,
            userId: currentUser?.id,
            classId: currentClass.id,
            orgId: currentOrg?.id
        }));
        setCreationType(null);
    };

    const navigateToStudentDashboard = (to) => {
        switch (to) {
            case "calendar":
                navigate("/student/class?view=assessments")
                break;
            case "studentData":
                navigate("/student/class?view=studentData")
                break;
            default:
                navigate("/student/class?view=home")
                break;
        }
    }
    const navigateToTeacherDashboard = (to) => {
        switch (to) {
            case "home":
                navigate("/admin/class?view=home")
                break;
            case "gradebook":
                navigate("/admin/class?view=gradebook")
                break;
            case "classdata":
                navigate("/admin/class?view=classdata")
                break;
            default:
                navigate("/admin/class?view=home")
                break;
        }
    }

    const toolbarNav = () => {
        const items = [
            ...(currentUser?.role === 'student' ? [{
                key: 'calendar',
                label: (
                    <StyledMenuItem style={{ borderBottom: "1px dotted white" }}>
                        <ButtonClear onClick={() => navigateToStudentDashboard("calendar")}>
                            calendar
                        </ButtonClear>
                    </StyledMenuItem>
                )
            }] : []),
            ...(currentUser?.role === 'student' ? [{
                key: 'studentData',
                label: (
                    <StyledMenuItem>
                        <ButtonClear onClick={() => navigateToStudentDashboard("studentData")}>
                            Student Data
                        </ButtonClear>
                    </StyledMenuItem>
                )
            }] : []),
            ...(currentUser?.role === 'teacher' ? [{
                key: 'home',
                label: (
                    <StyledMenuItem>
                        <ButtonClear onClick={() => navigateToTeacherDashboard("home")}>
                            Home
                        </ButtonClear>
                    </StyledMenuItem>
                )
            }] : []),
            ...(currentUser?.role === 'teacher' ? [{
                key: 'gradebook',
                label: (
                    <StyledMenuItem>
                        <ButtonClear onClick={() => navigateToTeacherDashboard("gradebook")}>
                            Gradebook
                        </ButtonClear>
                    </StyledMenuItem>
                )
            }] : []),
            ...(currentUser?.role === 'teacher' ? [{
                key: 'classdata',
                label: (
                    <StyledMenuItem>
                        <ButtonClear onClick={() => navigateToTeacherDashboard("classdata")}>
                            Class Data
                        </ButtonClear>
                    </StyledMenuItem>
                )
            }] : [])
        ];

        return { items };
    };

    const closeAssignment = () => {
        navigate(generateUrl(page, null, null))
    };

    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const setFlagsShowAnswer = (flag) => {
        setEbookFlagTeacherEdition(false);
        setEbookFlag(flag);
        setStudentViewFlag(false);
        if (flag === false) {
            revokeAnswerView();
        }
    }

    const onAnswerClick = () => {
       if(checkPopUpAtOnce()){
        return;
        }
        updatePopUpAtOnce(true);
        invokeAnswerView(answer_page);
    }

    const onPDFClick = () => {
        if(checkPopUpAtOnce()){
            return;
        }
        updatePopUpAtOnce(true);
        invokePDFView(pdf_page);
    }

    const setFlagsTeacherEdition = (flag) => {
        setEbookFlagTeacherEdition(flag);
        setEbookFlag(false);
        setStudentViewFlag(false);
    }


    const assignmentPreivew = (assignment) => {
        try {
            const assignmentData = assignment.data ? assignment.data : assignment
            if(assignmentData.activity_type === "graphic_organizer"){
                setOpenGraphicAssignmentPrivew(true)
                setGraphicAssignment(assignmentData)
            }else{
                setAssignmentData(assignment.data ? assignment.data : assignment)
                setPreview(true)
            }
        } catch (error) {
            Sentry.captureException(`516 Error in assignmentPreivew: ${error}`);
        }
    }
    const onPageSwipe = () => {
        setPreview(false)
        setAssignmentData({})
    }
    const hasActiveAssignmentDrawer = () => {
        return (typeof quiz == "string" && quiz.length > 2 && quiz !== 'null') || (typeof activity == "string" && activity.length > 2 && activity !== 'null')
    }
    const onChangeNumber = (newNumber) => {
        const v = new URLSearchParams(location.search).get("id");
        if(location.pathname.includes("stories")){
            if(!Array.isArray(story) || story.length === 0){
                return;
            }
            const currentStory = story.find(story => story.id === v);
            if(!currentStory || !Array.isArray(currentStory.levels)){
                return;
            }
            const searchParams = new URLSearchParams(location.search);
            const urlLevel = searchParams.get("level");
            const currentLevel = currentStory.levels.find(level => level.level === urlLevel);
            if(!currentLevel || !currentLevel.start || !currentLevel.finish){
                return;
            }
            const pages = content || data?.content || [];
            const pageStartIndex = pages.findIndex(p => p.pageId == currentLevel.start);
            const pageFinishIndex = pages.findIndex(p => p.pageId == currentLevel.finish);
            const pageIndex = parseInt(newNumber, 10) - 1;
            if(!isNaN(newNumber) && pageIndex >= 0 && pageStartIndex >= 0 && pageFinishIndex >= 0 && pageIndex <= (pageFinishIndex - pageStartIndex)){
                const targetPage = pages[pageStartIndex + pageIndex];
                if(targetPage){
                    navigate(generateUrl(targetPage.pageId,activity,quiz))
                    setPage(parseInt(targetPage.pageId, 10))
                }
            }else{
                setPage(parseInt(page, 10))
                navigate(generateUrl(page,activity,quiz))
            }
            return ;
        }
        const pages = content || data?.content || [];
        const balconPage = BALCON_PAGES.find(page => page.id === v);
        if(!balconPage){
            setPage(parseInt(page, 10))
            navigate(generateUrl(page,activity,quiz))
            setEbookFlag(false);
            revokeAnswerView();
            revokeMainbookView();
            updatePopUpAtOnce(false);
            return;
        }
        const pageStartIndex = pages.findIndex(p => p.pageId == balconPage.start);
        const pageFinishIndex = pages.findIndex(p => p.pageId == balconPage.finish);
        const pageIndex = parseInt(newNumber, 10) - 1;
        if(!isNaN(newNumber) && pageIndex >= 0 && pageStartIndex >= 0 && pageFinishIndex >= 0 && pageIndex <= (pageFinishIndex - pageStartIndex)){
            const targetPage = pages[pageStartIndex + pageIndex];
            if(targetPage){
                navigate(generateUrl(targetPage.pageId,activity,quiz))
                setPage(parseInt(targetPage.pageId, 10))
            }
        }else{
            setPage(parseInt(page, 10))
            navigate(generateUrl(page,activity,quiz))
        }
        setEbookFlag(false);
        revokeAnswerView();
        revokeMainbookView();
        if (!isStoryViewOpen()) updatePopUpAtOnce(false);
    }
    async function onAssignmentClick(act) {
        const uri =  generateUrl(page, act.data?.id, null);
        if (uri) {
            navigate(uri)
        }
    }
    const onBookClick = () =>{
       if(checkPopUpAtOnce()){
        return;
        }
          updatePopUpAtOnce(true);
        const mainBookFromIndex = findIndex(mainBookPages, p => p.pageId == get(hasMain_bookPage, "from", 0))
        const mainBookTo = findIndex(mainBookPages, p => p.pageId == get(hasMain_bookPage, "to", 0))
        if(mainBookFromIndex>=0 && mainBookTo>=0){
            const main_book_pages =  Array.isArray(mainBookPages) ? mainBookPages.slice(mainBookFromIndex,mainBookTo):[]
            invokeMainbookView(main_book_pages)
        }
       

    }

    const onWorkBookClick = () => {
          if(checkPopUpAtOnce()){
      return;
    }
    updatePopUpAtOnce(true);
        if (workbookPlanFromIndex >= 0 && workbookPlanTo >= 0) {
            const main_work_book_pages = Array.isArray(WorkbookPlanPages)
                ? WorkbookPlanPages.slice(workbookPlanFromIndex, workbookPlanTo + 1)
                : [];
            invokeMainbookView(main_work_book_pages);
        }
    }
    const lessionPlanFromIndex = useMemo(() => {
        if (!hasLessionPlanPage || !lessionPlanPages?.length) return -1;
        return findIndex(lessionPlanPages, p => p.pageId == get(hasLessionPlanPage, "from", 0));
    }, [hasLessionPlanPage, lessionPlanPages]);
    
    const lessionPlanTo = useMemo(() => {
        if (!hasLessionPlanPage || !lessionPlanPages?.length) return -1;
        return findIndex(lessionPlanPages, p => p.pageId == get(hasLessionPlanPage, "to", 0));
    }, [hasLessionPlanPage, lessionPlanPages]);

    const assignmentPlanFromIndex = useMemo(() => {
        if (!hasAssignmentPlanPage || !assignmentPlanPages?.length) return -1;
        return findIndex(assignmentPlanPages, p => p.pageId == get(hasAssignmentPlanPage, "from", 0));
    }, [hasAssignmentPlanPage, assignmentPlanPages]);
    
    const assignmentPlanTo = useMemo(() => {
        if (!hasAssignmentPlanPage || !assignmentPlanPages?.length) return -1;
        return findIndex(assignmentPlanPages, p => p.pageId == get(hasAssignmentPlanPage, "to", 0));
    }, [hasAssignmentPlanPage, assignmentPlanPages]);

    const unitExamPlanFromIndex = useMemo(() => {
        if (!hasUnitExamPlanPage || !unitExamPlanPages?.length) return -1;
        return findIndex(unitExamPlanPages, p => p.pageId == get(hasUnitExamPlanPage, "from", 0));
    }, [hasUnitExamPlanPage, unitExamPlanPages]);
    
    const unitExamPlanTo = useMemo(() => {
        if (!hasUnitExamPlanPage || !unitExamPlanPages?.length) return -1;
        return findIndex(unitExamPlanPages, p => p.pageId == get(hasUnitExamPlanPage, "to", 0));
    }, [hasUnitExamPlanPage, unitExamPlanPages]);

    const rubricsPlanFromIndex = useMemo(() => {
        if (!hasRubricsPlanPage || !rubricsPlanPages?.length) return -1;
        return findIndex(rubricsPlanPages, p => p.pageId == get(hasRubricsPlanPage, "from", 0));
    }, [hasRubricsPlanPage, rubricsPlanPages]);
    
    const rubricsPlanTo = useMemo(() => {
        if (!hasRubricsPlanPage || !rubricsPlanPages?.length) return -1;
        return findIndex(rubricsPlanPages, p => p.pageId == get(hasRubricsPlanPage, "to", 0));
    }, [hasRubricsPlanPage, rubricsPlanPages]);

    const workbookPlanFromIndex = useMemo(() => {
        if (!hasWorkbookPlanPage || !WorkbookPlanPages?.length) return -1;
        return findIndex(WorkbookPlanPages, p => p.pageId == get(hasWorkbookPlanPage, "from", 0));
    }, [hasWorkbookPlanPage, WorkbookPlanPages]);
    
    const workbookPlanTo = useMemo(() => {
        if (!hasWorkbookPlanPage || !WorkbookPlanPages?.length) return -1;
        return findIndex(WorkbookPlanPages, p => p.pageId == get(hasWorkbookPlanPage, "to", 0));
    }, [hasWorkbookPlanPage, WorkbookPlanPages])

    const newMaskId = get(
        find(get(data, "content"), (k) => k.pageId == page),
        "numberMasked",
        page
      );

 let isEmpty;
 if (!isStudent) {
   isEmpty =
     pageInteractions?.length === 0 &&
     videoSupport.length === 0 &&
     tipsTalented.length === 0 &&
     tipsSpecial.length === 0 &&
     availableActivity?.length === 0 &&
     assignableActivity?.length === 0 &&
     availableQuiz?.length === 0 &&
     assignableQuiz.length === 0  && 
     dataList?.length === 0
 } else {
   isEmpty =
     pageInteractions?.length === 0 &&
     videoSupport.length === 0 &&
     tipsTalented.length === 0 &&
     tipsSpecial.length === 0 &&
     availableQuiz?.length === 0 &&
     availableActivity?.length === 0 &&
     dataList?.length === 0
 }

 const has_activity = availableActivity?.length >0 || availableQuiz?.length >0 || assignableActivity?.length>0 || assignableQuiz?.length>0
 const has_student_activity = availableActivity?.length > 0 || availableQuiz?.length > 0;
 
 const isStudentTakingAssignment = useMemo(() => {
    if (!isStudent) return false;
    return (
      (typeof quiz === "string" && quiz.length > 2 && quiz !== "null") ||
      (typeof activity === "string" && activity.length > 2 && activity !== "null")
    );
  }, [isStudent, quiz, activity]);



  const handleForDistrictAdmin = () =>{
    if (currentUser.role === 'admin') {
      showAlert('Please login as teacher!' ,"error")
      return true;
    }
    return false;
  }

  const handleOpenStoryAi = () => {
    if (handleForDistrictAdmin()) return;
    if (checkPopUpAtOnce()) return;
    handleOpenStoryWithAi();
  }
  
    return (
        <SentryWrap>
        <>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={alertSakeBar.open}
                autoHideDuration={3000}
                onClose={()=>{ setAlertSakeBar({open:false,message:''})}}>
                <Alert onClose={()=>{ setAlertSakeBar({open:false,message:''})}} severity="error">
                    <strong>ALERT:</strong> {alertSakeBar.message}
                </Alert>
            </Snackbar>
            <TeachersWorkSheet setIsOpen={setIsOpen} isOpen={isOpen} book_id={CHAPTER_ID} page_id={page} numberMasked={`${parseInt(page) - parseInt(bookData?.start) + 1}`} />
            <Modal
                open={learnPlanModal}
                onClose={() => setLearnPlanModal(false)}
                className={"lessonPlanPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
            >
                <LearnPlanWrapper>
                    <LessionPlanContainer>
                        <CloseBtn onClick={() => { setLearnPlanModal(false); setLessionPageindex(0) }}>
                            <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }} />
                        </CloseBtn>
                        <div style={{ position: "absolute", right: "40px", top: "0px", zIndex: "1" }}>
                            <LessionPlanPrinter
                                onPrintSingle={handlePrintLessons}
                                printLoader={lessionPrintLoader} images={slice(lessionPlanPages, lessionPlanFromIndex > 0 ? lessionPlanFromIndex : 0, lessionPlanTo).map(k => k.resource).filter(k => k)} />
                        </div>
                        {/* <IconButton onClick={handlePrintLessons} aria-label="print"
                            style={{ position: "absolute", right: "40px", top: "0px", zIndex: "1" }}
                            disabled={lessionPrintLoader}>
                            {lessionPrintLoader ? <Loading size={20} /> : <PrintIcon />}
                        </IconButton> */}
                        {lessonPageindex > lessionPlanFromIndex && <ButtonContainer
                            ref={backBtnRef}
                            disabled={lessonPageindex <= lessionPlanFromIndex}
                            onClick={() => {
                                setLessionPageindex(lessonPageindex - 1)
                            }}
                            left={0}
                        >
                            <ArrowBackIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        {lessonPageindex < lessionPlanTo && <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={lessonPageindex >= lessionPlanTo}
                            onClick={() => {
                                setLessionPageindex(lessonPageindex + 1)
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        <LessionContainer>
                            <PrintWrapper ref={imageRef} className='to_be_print'>
                                <Images src={getSrcPage()} className='to_be_print' />
                            </PrintWrapper>
                        </LessionContainer>
                    </LessionPlanContainer>
                </LearnPlanWrapper>
            </Modal>
            <Modal
                open={assignmentPlanModal}
                onClose={() => setAssignmentPlanModal(true)}
                className={"lessonPlanPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
            >
                <LearnPlanWrapper>
                    <LessionPlanContainer>
                        <CloseBtn onClick={() => { setAssignmentPlanModal(false); setAssignmentPageindex(0) }}>
                            <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }} />
                        </CloseBtn>
                        <IconButton onClick={handlePrintLessons} aria-label="print"
                            style={{ position: "absolute", right: "40px", top: "0px", zIndex: "1" }}
                            disabled={assignmentPrintLoader}>
                            {assignmentPrintLoader ? <Loading size={20} /> : <PrintIcon />}
                        </IconButton>
                        {assignmentPageindex > assignmentPlanFromIndex && <ButtonContainer
                            ref={backBtnRef}
                            disabled={assignmentPageindex <= assignmentPlanFromIndex}
                            onClick={() => {
                                setAssignmentPageindex(assignmentPageindex - 1)
                            }}
                            left={0}
                        >
                            <ArrowBackIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        {assignmentPageindex < assignmentPlanTo && <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={assignmentPageindex >= assignmentPlanTo}
                            onClick={() => {
                                setAssignmentPageindex(assignmentPageindex + 1)
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        <LessionContainer>
                            <PrintWrapper ref={imageRef} className='to_be_print'>
                                <Images src={getSrcAssignmentPage()} className='to_be_print' />
                            </PrintWrapper>
                        </LessionContainer>
                    </LessionPlanContainer>
                </LearnPlanWrapper>
            </Modal>

              {/* unit exam */}
                <Modal
                open={unitExamPlanModal}
                onClose={() => setUnitExamPlanModal(false)}
                className={"lessonPlanPopUp"}
                style={{
                height: "100%",
                width: "100%",
                backgroundColor: "transparent",
                }}
            >
                <LearnPlanWrapper>
                <LessionPlanContainer>
                    <CloseBtn
                    onClick={() => {
                        setUnitExamPlanModal(false);
                        setUnitExamPageindex(0);
                    }}
                    >
                    <Close
                        style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }}
                    />
                    </CloseBtn>

                    <IconButton
                    onClick={handlePrintLessons}
                    aria-label="print"
                    style={{
                        position: "absolute",
                        right: "40px",
                        top: "0px",
                        zIndex: "1",
                    }}
                    disabled={unitExamPrintLoader}
                    >
                    {unitExamPrintLoader ? <Loading size={20} /> : <PrintIcon />}
                    </IconButton>
                    {unitExamPageIndex > unitExamPlanFromIndex && (
                    <ButtonContainer
                        ref={backBtnRef}
                        disabled={unitExamPageIndex <= unitExamPlanFromIndex}
                        onClick={() => {
                        setUnitExamPageindex(unitExamPageIndex - 1);
                        }}
                        left={0}
                    >
                        <ArrowBackIos style={{ fontSize: "40px" }} />
                    </ButtonContainer>
                    )}
                    {unitExamPageIndex < unitExamPlanTo && (
                    <ButtonContainer
                        ref={forwardBtnRef}
                        disabled={unitExamPageIndex >= unitExamPlanTo}
                        onClick={() => {
                        setUnitExamPageindex(unitExamPageIndex + 1);
                        }}
                        right={0}
                    >
                        <ArrowForwardIos style={{ fontSize: "40px" }} />
                    </ButtonContainer>
                    )}
                    <LessionContainer>
                    <PrintWrapper ref={imageRef} className='to_be_print'>
                        <Images src={getSrcUnitExamPage()} className='to_be_print' />
                    </PrintWrapper>
                    </LessionContainer>
                </LessionPlanContainer>
                </LearnPlanWrapper>
            </Modal>

              {/* rubrics plan modal */}

              <Modal
                open={rubricsPlanModal}
                onClose={() => setRubricsPlanModal(true)}
                className={"rubricsPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
            >
                <LearnPlanWrapper>
                    <LessionPlanContainer>
                        <CloseBtn onClick={() => { setRubricsPlanModal(false); setRubricsPageindex(0) }}>
                            <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }} />
                        </CloseBtn>
                       
                        <IconButton onClick={handlePrintLessons} aria-label="print"
                            style={{ position: "absolute", right: "40px", top: "0px", zIndex: "1" }}
                            disabled={rubricsPrintLoader}>
                            {rubricsPrintLoader ? <Loading size={20} /> : <PrintIcon />}
                        </IconButton>
                        
                        {rubricsPageindex > rubricsPlanFromIndex && <ButtonContainer
                            ref={backBtnRef}
                            disabled={rubricsPageindex <= rubricsPlanFromIndex}
                            onClick={() => {
                                setRubricsPageindex(rubricsPageindex - 1)
                            }}
                            left={0}
                        >
                            <ArrowBackIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        {rubricsPageindex < rubricsPlanTo && <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={rubricsPageindex >= rubricsPlanTo}
                            onClick={() => {
                                setRubricsPageindex(rubricsPageindex + 1)
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}

                        <LessionContainer>
                            <PrintWrapper ref={imageRef} className='to_be_print'>
                                <Images src={getSrcRubricsPage()} className='to_be_print' />
                            </PrintWrapper>
                        </LessionContainer>
                        
                    </LessionPlanContainer>
                </LearnPlanWrapper>
            </Modal>
            {/* end of rubrics plan */}
            {/* Workbook plan modal start */}
            <Modal
                open={workbookPlanModal}
                onClose={() => setWorkbookPlanModal(true)}
                className={"lessonPlanPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
            >
                <LearnPlanWrapper>
                    <LessionPlanContainer>
                        <CloseBtn onClick={() => { setWorkbookPlanModal(false); setWorkbookPageindex(0) }}>
                            <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 25 }} />
                        </CloseBtn>

                        {/* <IconButton onClick={handlePrintLessons} aria-label="print"
                            style={{ position: "absolute", right: "40px", top: "0px", zIndex: "1" }}
                            disabled={assignmentPrintLoader}>
                            {assignmentPrintLoader ? <Loading size={20} /> : <PrintIcon />}
                        </IconButton> */}
                        {WorkbookPageindex > workbookPlanFromIndex && <ButtonContainer
                            ref={backBtnRef}
                            disabled={WorkbookPageindex <= workbookPlanFromIndex}
                            onClick={() => {
                                setWorkbookPageindex(WorkbookPageindex - 1)
                            }}
                            left={0}
                        >
                            <ArrowBackIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        {WorkbookPageindex < workbookPlanTo && <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={WorkbookPageindex >= workbookPlanTo}
                            onClick={() => {
                                setWorkbookPageindex(WorkbookPageindex + 1)
                            }}
                            right={0}
                        >
                            <ArrowForwardIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>}
                        <LessionContainer>
                            <PrintWrapper ref={imageRef}>
                                <Images src={getSrcWorkbookPage()} />
                            </PrintWrapper>
                        </LessionContainer>
                    </LessionPlanContainer>
                </LearnPlanWrapper>
            </Modal>

            {/* Workbook plan modal end */}
            {customAssignmentDrawer ? (
              <AssignmentForm
                open={customAssignmentDrawer}
                onClose={() => {
                  setCustomAssignmentDrawer(false);
                  setAssignmentBuilderSeed(null);
                }}
                bookId={CHAPTER_ID}
                pageId={page}
                from="balcon"
                pageSrc={pageSrc}
                ai_questions={assignmentBuilderSeed?.ai_questions}
                assignmentTitle={assignmentBuilderSeed?.assignmentTitle}
              />
            ) : null}
            {assignmentBuilderOpen && <AssignmentBuilderTool
              open={assignmentBuilderOpen}
              onClose={() => setAssignmentBuilderOpen(false)}
              data={data}
              page={page}
              chapter={CHAPTER_ID}
              from={getCurrentResourceType(CHAPTER_ID) || 'balcon'}
              pageSrc={pageSrc}
              pageTitle={pageNumber}
              BALCON_PAGES={BALCON_PAGES}
              generatedTest
            />}
            <Row span={17} className="BalconMobleView tolBOxSection btnContSpacing" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center",}}>
                {isDrawerOpen && <Close onClick={closeDrawer}
                    style={{ color: "red", fontWeight: "bolder", fontSize: 35, position: 'absolute', top: 20, left: 20, cursor: "pointer" }}
                />}
                            {/* <TimmerWrapper>
                                {timeInt !== 0 && currentUser?.role == 'student' ? timeInt : ""}
                            </TimmerWrapper> */}
                <PlannerWrapper className="tolingSectionAddOn">

                
                    {isStudent && <DummyBtn></DummyBtn>}
                                        {!preview && isTeacher ? (
                                    <AssignmentPlan  onClick={() => setCustomAssignmentDrawer(true)}  className='ebooks-button'>
                                        {/* #TODO Cna be enable after testing on prod. */}
                                        <AssignmentPlanInner>
                                        <Add style={{ fontSize: '13px', fontWeight:700 }} />
                                        Assignment
                                        </AssignmentPlanInner>
                                      
                                    </AssignmentPlan>
                                ) : null}
                                {/* {hasLessionPlanPage && currentUser?.role !== "student" ? (<LessionPlan onClick={() => {
                                    if (get(orgPermissions, "lessonPlan", true)) {
                                        setLearnPlanModal(true)
                                        setLessionPageindex(lessionPlanFromIndex)
                                    } else {
                                        setAlertSakeBar({ open: true, message: 'Restricted access (legend)' })
                                    }
                                }}>
                                    <LessionPlanInner>{hasLessionPlanPage?.levelTitle?.length > 0 ? hasLessionPlanPage?.levelTitle : "Lesson Plan"} </LessionPlanInner>
                                </LessionPlan>) : null} */}
                                 <LessonPlan imageRef={imageRef} pageId={page} lessonPlanData={lessonPlan} handlePrintLessons={handlePrintLessons} lessionPrintLoader={lessionPrintLoader} setLearnPlanModals={setLearnPlanModal} learnPlanModals={learnPlanModal} chapter={CHAPTER_ID} data={data} />
                                         
                                {/* {sentenceData?.id && (<AssignmentPlan onClick={() => {
                                    invokeSentenceView(sentenceData);
                                }}>
                                    <AssignmentPlanInner>Sentence starters</AssignmentPlanInner>
                                </AssignmentPlan>)} */}
                               
                                {isSentenceStarterAllowedForBookGroup && <SentenceViewTooling  pageId={page} book={book} />}
                              
                                <QuizHandler 
                                states={{ 
                                    // this for quiz
                                    hasAssignmentPlanPage,currentUser,assignmentPlanFromIndex,
                                    //this for unit quiz
                                    hasUnitExamPlanPage, unitExamPageIndex
                                }} 
                                funcObj={{ setAssignmentPlanModal,setAssignmentPageindex,setUnitExamPageindex, setUnitExamPlanModal}} 
                                />
                                {/* {hasAssignmentPlanPage && currentUser?.role !== "student" ? (<AssignmentPlan onClick={() => {
                                    setAssignmentPlanModal(true)
                                    setAssignmentPageindex(assignmentPlanFromIndex)
                                }}>
                                    <AssignmentPlanInner>Quiz</AssignmentPlanInner>
                                </AssignmentPlan>) : null} */}
                                {hasRubricsPlanPage && currentUser?.role !== "student" ? (<AssignmentPlan onClick={() => {
                                     if(checkPopUpAtOnce()){
                                        return;
                                    }
                                    setRubricsPlanModal(true)
                                    setRubricsPageindex(rubricsPlanFromIndex)
                                }}>
                                    <AssignmentPlanInner>Rubrics</AssignmentPlanInner>
                                </AssignmentPlan>) : null}
                                {hasWorkbookPlanPage && currentUser?.role !== "student" ? (<AssignmentPlan onClick={() => {
                                    // setWorkbookPlanModal(true)
                                    // setWorkbookPageindex(workbookPlanFromIndex)
                                    onWorkBookClick()
                                }}>
                                    <AssignmentPlanInner>Workbook</AssignmentPlanInner>
                                </AssignmentPlan>) : null}
                                {hasMain_bookPage && currentUser?.role === "teacher" ? (<AssignmentPlan onClick={onBookClick}>
                                    <AssignmentPlanInner>Assessment Book</AssignmentPlanInner>
                                </AssignmentPlan>) : null}
                            </PlannerWrapper>


                        </Row>
            <Wrapper  className="ebokToolUpr">
     
            <Toolbar>
                    <Row style={{   paddingTop: "9px",
              paddingBottom: "11px",
              paddingLeft: "9px",
              paddingRight: "9px",
              width: "100%",
              justifyContent: "space-between",
              backgroundColor: "#012B70",}}>
                        <Col span={5}  style={{ display:"flex" , justifyContent:"flex-start" , alignItems:"center" }} >
                            <Page style={{ color: "#ffffff" }}>
                           {!isStudent? <PrintAction isDemo={isDemo} isReviewAccount={isReviewAccount} handleImagePrint={handleImagePrint} printLoader={printLoader} chapter={CHAPTER_ID} pageId={page} from={"balcon"} images={content&&content.length>0?content.map(k=>k.src):null} pageSrc={pageSrc} />:null}
                                P.
                                <PageEditor
                                    activity={activity}
                                    chapter={CHAPTER_ID}
                                    limit={limit}
                                    page={page}
                                    quiz={quiz}
                                    value={pageNumber}
                                    numberMasked={pageNumber}
                                    onChangeNumber={onChangeNumber}
                                />
                            </Page>

                        </Col>
                                            
                        <Col span={2}  style={{ display:"flex" , justifyContent:"flex-end" , alignItems:"center", marginRight: "10px" }}>
                        {
                            currentUser?.role === "student" && (
                                isDrawerOpen ? (
                                <FullscreenExitIcon  sx={{ color: 'white', fontSize: '41px', cursor: 'pointer' }} onClick={toggleDrawer} />
                            ) : (
                                <FullscreenIcon sx={{ color: 'white', fontSize: '41px', cursor: 'pointer' }} onClick={toggleDrawer} />
                            )
                            )
                        }
                        <BubbleNotes
                        pageName={backToLabelStory === "Stories" ? "stories" : "balcon"}
                  pageSrc={pageSrc}
                  data={data}
                  page={page}
                  newMaskNote={pageNumber}
                  currentUser={currentUser}
                  pageNotes={pageNotes}
                  chapter={CHAPTER_ID}
                  dataBook={dataBook}
                  BALCON_PAGES={BALCON_PAGES}
                  storyId={storyId}
                  level={storyLevel}
                />
               
                            <DropdownMenu isStudent={isStudent} isTeacher={isTeacher} isAdmin={isAdmin} navigate={isTeacher ? navigateToTeacherDashboard : navigateToStudentDashboard} />

                        </Col>
                    </Row>
                </Toolbar>
                {isStudent && (
                    <div className="mt-10px">
                    <Wrap className="ebokToolWrap">
                      <div className='newEbokToolWrap newEbokToolSwitch setWdthSwitchInfor'>
                        <ExtensionActivitiesTooling pageId={page} />
                        <CommonEbookTooling bookId={CHAPTER_ID} pageId={page} />
                       </div> 
                    </Wrap>
                    </div>
                )}
             
                {!isStudent && (
                    <div className='mt-10px'>
                      <Wrap className="ebokToolWrap" empty={!(existTeacherEdition && hasteacherEdition) && !existSpecialSupport && !(existShowAnswer || existStudentView) && !links && !(tips?.length > 0)} >
                        <div className='newEbokToolWrap newEbokToolSwitch setWdthSwitchInfor'>
                          
                           <ExtensionActivitiesTooling pageId={page} />

                            {existTeacherEdition && hasteacherEdition && (
                                <TeacherEditionList booksAllList={booksAllList} page={page} dataBook={dataBook} links={links} ebookFlagTeacherEdition={ebookFlagTeacherEdition} setFlagsTeacherEdition={(value) => {
                                    setFlagsTeacherEdition(value)
                                    setEbookFlagPageLink(false)
                                    setToolsDropdown(false)
                                  }}
                                />
                            )}
                            {/* {existTeacherEdition && hasteacherEdition && (
                                <FormControlLabel
                                    className="teacher-stag-root"
                                    control={
                                        <Switch
                                            size="small"
                                            checked={ebookFlagTeacherEdition}
                                            onChange={e => setFlagsTeacherEdition(e.target.checked)}
                                            name="viewTeacherEdition"
                                            color="primary"
                                        />
                                    }
                                    label="Teacher Edition 234567"
                                />
                            )} */}
                            {existSpecialSupport && (
                                <StyledFormControlLabel
                                    className="teacher-stag-root"
                                    control={
                                        <Switch
                                            size="small"
                                            checked={showSpecialSupport}
                                            onChange={e =>  setShowSpecialSupport(e.target.checked)}
                                            name="viewSpecialSupport"
                                            color="primary"
                                        />
                                    }
                                    label="Additional support"
                                />
                            )}
                            {(existShowAnswer || existStudentView) && (
                                <>
                                    {existShowAnswer && (
                                        <StyledFormControlLabel
                                            className="teacher-stag-root"
                                            control={
                                                <StyledSwitch
                                                    size="small"
                                                    checked={ebookFlag}
                                                    onChange={async e => {
                                                        setToolsDropdown(false);
                                                        if (e.target.checked) {
                                                            // if(openPopUpAtOnce){ 
                                                            //   checkPopUpAtOnce();
                                                            //   return;
                                                            // }
                                                            updatePopUpAtOnce(true);
                                                            onAnswerClick()
                                                            setFlagsShowAnswer(e.target.checked)
                                                            setToolsDropdown(false)
                                                        }
                                                        else if(!e.target.checked) {
                                                            updatePopUpAtOnce(false);
                                                            revokeAnswerView()
                                                            setFlagsShowAnswer(e.target.checked)
                                                            setToolsDropdown(false)
                                                        }
                                                    }}
                                                    name="viewFlag"
                                                    color="primary"
                                                />
                                            }
                                            label="Show Answers"
                                        />
                                    )}
                                </>
                            )}
                            {hasActivitiesWithStandards && (
                                <AssignmentPlan
                                    onClick={async () => {
                                        setToolsDropdown(false);
                                        if (activityStandardsView.open) {
                                            updatePopUpAtOnce(false);
                                            revokeActivityStandardsView();
                                        } else {
                                            if (openPopUpAtOnce) {
                                                checkPopUpAtOnce();
                                                return;
                                            }
                                            updatePopUpAtOnce(true);
                                            const units = data?.structures || [];
                                            const pages = data?.content || [];
                                            invokeActivityStandardsView(allActivitiesForStandards, standards, enabledStateCodes, bookData, units, pages, page);
                                        }
                                    }}
                                    className='ebooks-button'
                                    style={{ marginLeft: '4px', marginTop: '5px' }}
                                >
                                    <AssignmentPlanInner>
                                        Show Standards
                                        {activityStandardsView.open && <span style={{ marginLeft: '4px' }}>✓</span>}
                                    </AssignmentPlanInner>
                                </AssignmentPlan>
                            )}
                            {pdf_page && currentUser?.role === 'teacher' && (
                                <StyledFormControlLabel
                                    className="teacher-stag-root"
                                    control={
                                        <StyledSwitch
                                            size="small"
                                            checked={pdfView.open}
                                            onChange={async e => {
                                                setToolsDropdown(false);
                                                if (e.target.checked) {
                                                    if(checkPopUpAtOnce()){ 
                                                      return;
                                                    }
                                                    onPDFClick()
                                                }
                                                else if(!e.target.checked) {
                                                    updatePopUpAtOnce(false);
                                                    revokePDFView();
                                                }
                                            }}
                                            name="viewPDF"
                                            color="primary"
                                        />
                                    }
                                    label="View as PDF"
                                />
                            )}
                            {tips?.length > 0 && (
                                <StyledFormControlLabel
                                    className="teacher-stag-root"
                                    control={
                                        <Switch
                                            size="small"
                                            checked={teacher_strategies}
                                            onChange={e => {
                                                if(e.target.checked){
                                                    if(checkPopUpAtOnce()){ 
                                                      return;
                                                    }
                                                    updatePopUpAtOnce(true);
                                                    setTeacherStrategies(e.target.checked)
                                                  }else{
                                                    setTeacherStrategies(e.target.checked)
                                                    updatePopUpAtOnce(false);
                                                  }
                                               
                                            }}
                                            name="viewTeacherEdition"
                                            color="primary"
                                        />
                                    }
                                    label="Teacher strategies"
                                 />
                            )}
                             <LinkList links={pageHyperlink} ebookFlagTeacherEdition={ebookFlagTeacherEdition} ebookFlagPageLink={ebookFlagPageLink} setEbookFlagPageLink={(val) => {
                                  setEbookFlagPageLink(val);
                                  setFlagsTeacherEdition(false);
                             }} />
                             <CommonEbookTooling bookId={CHAPTER_ID} pageId={page} />
                        </div>
                      </Wrap>
                    </div>
                )}
                  
                {/* end toogle buttons */}

                {!isStudentTakingAssignment && (
                <>
                
                <div className='balconCultMain' style={{marginBottom: '0px'}}>
                    {!isStudent && 

                        <BingoModal page={page} chapter={CHAPTER_ID} newMaskId={pageNumber} pageLearningModuleCount={pageLearningModuleCount} />
                    }
                    {(isTeacher || isDistrictAdmin) && (
                            <OnegameModals
                                aiModal={aiModals}
                                setAiModal={setAiModals}
                                booksAllList={booksAllList}
                                chapter={CHAPTER_ID}
                                page={page}
                                currentClass={currentClass}
                                currentUser={currentUser}
                                page_1game_ai_content={page_1game_ai_content}
                                newMaskId={pageNumber}
                                backToLabelStory={backToLabelStory}
                                bookUnits={data?.structures}
                                gameCardId={newMaskId}
                                book_content={content}
                            />
                    )}
                        <OnestudyModals
                            aiModal={studyModals}
                            setAiModal={setStudyModals}
                            booksAllList={booksAllList}
                            chapter={CHAPTER_ID}
                            page={page}
                            currentClass={currentClass}
                            currentUser={currentUser}
                            page_1game_ai_content={page_1game_ai_content}
                            newMaskId={pageNumber}
                            backToLabelStory={backToLabelStory}
                            bookUnits={data?.structures}
                            book_content={content}
                            studyCardId={newMaskId}
                        />
                    {(isTeacher || isDistrictAdmin) && (
                        <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                            <button onClick={handleOpenStoryAi} className='addOneImg'>
                                <Badge 
                            overlap="rectangular" 
                            badgeContent={
                              pageLearningModuleCount?.soy_historias_status && 
                              Array.isArray(hasStoryWithAi) && 
                              hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0
                                ? "✓" 
                                : undefined
                            } 
                            color="success" 
                            variant="standard"
                            sx={{width: '100%'}}
                        >
                                <img src={SoyHistoriasIconUpdated} alt='SoyHistorias' title='SoyHistorias' />
                            </Badge>
                            </button>
                        
                        </div>
                    )}
                    {isStudent && Array.isArray(hasStoryWithAi) && hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0 && (
                        <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                            <button onClick={() => {
                                if (checkPopUpAtOnce()) return;
                                handleOpenStoryWithAi();
                            }} className='addOneImg'>
                            <Badge 
                            overlap="rectangular" 
                            badgeContent={
                              pageLearningModuleCount?.soy_historias_status && 
                              Array.isArray(hasStoryWithAi) && 
                              hasStoryWithAi.filter(item => !isErrorContent(item?.story_content || '')).length > 0
                                ? "✓" 
                                : undefined
                            } 
                            color="success" 
                            variant="standard"
                            sx={{width: '100%'}}
                        >
                                <img src={SoyHistoriasIconUpdated} alt='SoyHistorias' title='SoyHistorias' />
                            </Badge>
                            </button>
                        </div>
                    )}
                    {!isStudent && (
                        <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} >
                
                        <button onClick={() => {if (handleForDistrictAdmin()) return;
                        if(checkPopUpAtOnce()){
                            return;
                            }
                            updatePopUpAtOnce(true);
                        setIsOpen(true) }} className='addOneImg'>
                            <Badge 
                            overlap="rectangular" 
                            badgeContent={pageLearningModuleCount?.worksheet_status ? "✓" : undefined} 
                            color="success" 
                            variant="standard"
                            sx={{width: '100%'}}
                        >
                            <img src={GrammerIconDrill} alt="Grammar Drills" title="Grammar Drills" />
                            </Badge>
                        </button>
                        </div>
                        )}
                    {!isStudent && Boolean(page_slide && page_slide.id) && <button onClick={() => handlerOpenPresentation()} className='addOneImg'>
                        <Badge 
                            overlap="rectangular" 
                            badgeContent={"✓"} 
                            color="success" 
                            variant="standard"
                            sx={{width: '100%'}}
                        >
                            <img src={PresentationIconSvg} alt="Presentation" title="Presentation" />
                        </Badge>
                        </button>
                        }
                    {!isStudent && <button onClick={handleGenerateAiAssignment} className='addOneImg'><img src={AiActivityIcon} alt="Ai Activity" title="Ai Activity" /></button>}
                    {!isStudent  && (
                        <div className="vocOrGame" style={{ display: "flex", justifyContent: "center" }}>
                        <GraphicOrganizerAssignments page={page} chapter={CHAPTER_ID} isResource={true} />
                        </div>
                    )}
                    {!isStudent && <GraphicAssignmentPreview open={openGraphicAssignmentPrivew} setOpen={setOpenGraphicAssignmentPrivew} assignment={graphicAssignment} page_id={page}  bookId={CHAPTER_ID} />}
                
                </div>
                <div className='balconCultMain' style={{marginTop: '0px'}}>
                    {!isStudent && <TestGenerator
                                type="button"
                                onClick={() => {
                                    if (handleForDistrictAdmin()) return;
                                    setAssignmentBuilderOpen(true);
                                }}
                                className="addOneImg"
                                style={{ flex: 1, width: '100%' }}
                                title="Assignment Builder"
                            >
                                <img src={GenerateTestIcon} alt="Generate Test" title="Generate Test" />
                            </TestGenerator>}

                </div>
                </>

                )}
        
                <ParentContainer style={{
                    maxHeight:
                    preview
                    ? window.innerWidth <= 1250
                    ? "600px"
                    : window.innerWidth <= 1330
                    ? "800px"
                    : "900px"
                    : imageConfiguration?.clientHeight - 172, 
                    marginTop: "10px",
                    paddingInline: "12px",
                }}
                    className={`${isDrawerOpen ? 'toolingSectionInDrawerBalcon' : 'scrolingToolss'}`}
                isStudent={isStudent}>
                <TeacherStrategies showCopyRight={showCopyRight} teacher_strategies={teacher_strategies}  tips={tips}/>
                {pageInteractions?.length > 0 && (
                        <Section style={{gap: "11px", paddingTop: '0px' }} className="playAudio balconPlayAudioPaddingTop0">
                            {pageInteractions?.map((action, index) => (
                                <Interaction key={action.id} data={action} page="balcon" pageId={page} chapter={CHAPTER_ID} index={index} />
                            ))}
                        </Section>
                    )}
                     {currentUser?.role === 'teacher' && has_activity && ap_video && ap_video.id && (
                        <Section className="playAudio balconPlayAudio">
                            <Interaction key={ap_video.id} data={ap_video} page="balcon"   pageId={page} chapter={CHAPTER_ID}/>
                        </Section>
                    )}
                    {currentUser?.role === 'student' && has_student_activity && ap_video && ap_video.id && (
                        <Section className="playAudio balconPlayAudioPaddingTop0">
                            <Interaction key={ap_video.id} data={ap_video} page="balcon"  pageId={page} chapter={CHAPTER_ID} />
                        </Section>
                    )}
                <div >
                     <VideoSupport  showCopyRight={showCopyRight} showSpecialSupport={showSpecialSupport} videoSupport={videoSupport} />
                   
                       
                            <AssignmentsComponent bookId={CHAPTER_ID} pageId={page} id={id} 
                            student_render_assignments={true} from="balcon"
                            timeInt={timeInt}
                            timmer={timmer}
                            assignmentAllRefs={assignmentAllRefs}
                            setSubmitRef={setSubmitRef}
                            onFinish={ onFinish }
                            isStudentTakingAssignment={isStudentTakingAssignment}
                            pageLearningModuleCount={pageLearningModuleCount}
                            newMaskId={pageNumber}
                            toggleDrawer={toggleDrawer}
                            closeSideDrawer={closeDrawer}
                            isDrawerOpen={isDrawerOpen}
                            />
                 
                </div>
                </ParentContainer>

            </Wrapper>
            </>
        </SentryWrap>
    );
};



//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    activities: state.activities,
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentClass: state.currentClass,
    currentOrg: state.currentOrg,
    currentUser: state.currentUser,
    interactions: state.interactions,
    notes: state.notes,
    quizzes: state.quizzes,
    submissions: state.submissions,
    booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(BalconCulturalTooling);